export default "__VITE_ASSET__C6k7TQJ2__"